export const getInitials = userName => {
  if (!userName || userName.length === 0) {
    return '';
  }

  const initials = userName.split(' ').reduce((accumulator, currentValue, currentIndex, array) => {
    if (currentIndex === 0 || currentIndex === array.length - 1) {
      // eslint-disable-next-line no-param-reassign
      accumulator += currentValue[0];
    }

    return accumulator;
  }, '');

  return initials.toUpperCase();
};
